import Swiper, { Navigation, Pagination } from 'swiper'
import { elementsToMaxHeight } from "../helpers/elementsToMaxSizes"

export class ElementSlider {

  constructor ($element) {
    this.slider = this.init($element)
  }

  init($element) {

    if ($element.find('.swiper-slide').length) {
      let loop = $element.data('loop') == 'true' || $element.data('loop') == '1' ? true : false;
      let prevB = $element.find('.js-slider-prev')[0]
      let nextB = $element.find('.js-slider-next')[0]

      // set equal heights
      setTimeout(function(){
        elementsToMaxHeight($element.find('.js-equal-height')) 
      }, 200);


      return new Swiper($element[0], {
        modules: [Navigation, Pagination],
        slidesPerView: "auto",
        freeMode: true,
        loop: loop,
        navigation: {
          nextEl: nextB,
          prevEl: prevB,
        },
        pagination: {
          el: $element.find('.js-pagination')[0],
          type: "fraction",
          renderFraction: function (currentClass, totalClass) {
            return `<span class="${currentClass}"></span><span>/</span><span class="${totalClass}"></span>`
          }
        },
        on: {
          init: function () {
            checkArrowsVisibility(this);
          },
          resize: function () {
            checkArrowsVisibility(this);
          }
        }
      })

    }
  

  }

  destroy() {
    if(this.slider) {
      this.slider.destroy(true, true)
    }
  }

}


// Initialize slider automatically if set auto init parameter
$(document).ready(function(){
  $('.js-element-slider[data-auto-init="1"]').each(function (){
    let slider = new ElementSlider($(this))
  })
})


// hide arrows if all slides in screen
function checkArrowsVisibility(swiper) {
  const slidesInView = swiper.slides.length <= Math.floor((swiper.width + 50) / swiper.slides[0].swiperSlideSize);
  const arrows = swiper.$el.find('.element-slider-next, .element-slider-prev');
  
  if (slidesInView) {
    arrows.css('display','none');  // Hide arrows
  } else {
    arrows.css('display','inline-block');
  }
}